import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { routeNames } from "../../consts/routesNames";
import { useAuth } from "../../auth/hooks/usePermissions";
import {
  clearAuthSessionCookies,
  notifyAuthSessionChanged,
} from "../../auth/utils/session";
import { configureAxios } from "../../utils/axiosConfig";

function RequireContactLink({ children }) {
  const { isAuthenticated, isAdmin, contactId } = useAuth();
  const mustRedirectToLogin = isAuthenticated && !isAdmin && contactId == null;

  useEffect(() => {
    if (!mustRedirectToLogin) return;
    clearAuthSessionCookies();
    configureAxios();
    notifyAuthSessionChanged();
  }, [mustRedirectToLogin]);

  if (!isAuthenticated) {
    return <Navigate to={routeNames.LOGIN} replace />;
  }

  if (mustRedirectToLogin) {
    return <Navigate to={routeNames.LOGIN} replace />;
  }

  return children ?? <Outlet />;
}

RequireContactLink.propTypes = {
  children: PropTypes.node,
};

export default RequireContactLink;
